/* ms-soul-elements-grid.js — Mindful Sips */

(function () {
  'use strict';

  /* ── Carousel prev / next ──────────────────────────────────────────────── */

  document.querySelectorAll('.ms-seg__carousel').forEach(function (carousel) {
    var track   = carousel.querySelector('.ms-seg__grid');
    var prevBtn = carousel.querySelector('.js-seg-prev');
    var nextBtn = carousel.querySelector('.js-seg-next');

    if (!track || !prevBtn || !nextBtn) return;

    function getScrollAmount() {
      var card = track.querySelector('.ms-seg__card');
      if (!card) return 400;
      /* card width + gap (20px) */
      return card.offsetWidth + 20;
    }

    prevBtn.addEventListener('click', function () {
      track.scrollBy({ left: -getScrollAmount(), behavior: 'smooth' });
    });

    nextBtn.addEventListener('click', function () {
      track.scrollBy({ left: getScrollAmount(), behavior: 'smooth' });
    });

    /* Disable prev at start, next at end */
    function updateButtons() {
      prevBtn.disabled = track.scrollLeft <= 0;
      nextBtn.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 1;
    }

    track.addEventListener('scroll', updateButtons, { passive: true });
    updateButtons();
  });

}());
